import { apiPost } from 'api';
import { UpdateConsulteeRequest } from '../../types';
import { EmptyObject } from 'types';

export const updateConsultee = (request: UpdateConsulteeRequest): Promise<EmptyObject> =>
  apiPost<EmptyObject, UpdateConsulteeRequest>(`users/${request.id}/edit`, request);
